import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  for: "active",
  class: "kn-material-input-label p-mr-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Message = _resolveComponent("Message")
  const _component_FileUpload = _resolveComponent("FileUpload")
  const _component_InputSwitch = _resolveComponent("InputSwitch")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")
  const _directive_t = _resolveDirective("t")

  return (_openBlock(), _createBlock(_component_Dialog, {
    class: "kn-dialog--toolbar--primary importFileDialog",
    visible: _ctx.visibility,
    footer: "footer",
    header: _ctx.$t('common.import'),
    closable: false,
    modal: ""
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "p-button-text kn-button",
        label: _ctx.$t('common.cancel'),
        onClick: _ctx.closeDialog
      }, null, 8, ["label", "onClick"]),
      _withDirectives(_createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        disabled: _ctx.uploadedFiles && _ctx.uploadedFiles.length == 0,
        onClick: _ctx.startImportFile
      }, null, 8, ["disabled", "onClick"]), [
        [_directive_t, 'common.import']
      ])
    ]),
    default: _withCtx(() => [
      (_ctx.checkExistingFile())
        ? (_openBlock(), _createBlock("span", _hoisted_1, [
            _createVNode(_component_Message, { severity: "warn" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('managers.resourceManagement.uploadFile.fileWillBeOverwritten')), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.notifyExtractionWarning())
        ? (_openBlock(), _createBlock("span", _hoisted_2, [
            _createVNode(_component_Message, { severity: "warn" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('managers.resourceManagement.uploadFile.fileAndFoldersContentWillBeOverwritten')), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_FileUpload, {
        name: "demo[]",
        chooseLabel: _ctx.$t('common.choose'),
        customUpload: true,
        onUploader: _ctx.onUpload,
        onRemove: _ctx.onDelete,
        auto: "true",
        maxFileSize: 50000000,
        multiple: false,
        fileLimit: 1
      }, {
        empty: _withCtx(() => [
          _createVNode("p", null, _toDisplayString(_ctx.$t('common.dragAndDropFileHere')), 1)
        ]),
        _: 1
      }, 8, ["chooseLabel", "onUploader", "onRemove"]),
      (_ctx.isArchive())
        ? (_openBlock(), _createBlock("span", {
            key: 2,
            class: _ctx.notifyExtractionWarning() || _ctx.checkExistingFile() ? 'inputFileToggleWithToolbar' : 'inputFileToggle'
          }, [
            _createVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('managers.resourceManagement.extract')), 1),
            _createVNode(_component_InputSwitch, {
              modelValue: _ctx.checked,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.checked = $event))
            }, null, 8, ["modelValue"])
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible", "header"]))
}